import { splitProtocolGroups } from "./hex";
import { getProtocolString } from "./source";

export function parseHistoryData(protocol) {
  const tds = getProtocolString(protocol, "mrtdsHist");

  return {
    temperatures: splitProtocolGroups(getProtocolString(protocol, "shuiWenHist"), 3, {
      radix: 10,
      scale: 10,
      digits: 1
    }),
    peakPureWaterFlow: splitProtocolGroups(
      getProtocolString(protocol, "csllfzHist"),
      4,
      { radix: 16, scale: 100, digits: 2 }
    ),
    dailyPureWaterFlow: splitProtocolGroups(
      getProtocolString(protocol, "mrccsHist"),
      3,
      { radix: 16, scale: 10, digits: 1 }
    ),
    dailyInletWaterFlow: splitProtocolGroups(
      getProtocolString(protocol, "mryysHist"),
      3,
      { radix: 16, scale: 10, digits: 1 }
    ),
    inletTds: splitProtocolGroups(tds.slice(0, 124), 4),
    pureWaterTds: splitProtocolGroups(tds.slice(124), 4)
  };
}

export function createDateLabels(length) {
  const safeLength = Number(length);
  if (!Number.isFinite(safeLength) || safeLength <= 0) {
    return [];
  }

  const labels = [];
  for (let index = safeLength - 1; index >= 0; index -= 1) {
    const date = new Date();
    date.setDate(date.getDate() - (safeLength - 1 - index));
    labels.push(String(date.getDate()));
  }

  return labels.reverse();
}
